import type { UserProfile } from "@/components/feature/Sidebar";
export type { UserProfile };


export const mockUsers: Record<string, UserProfile> = {
  "director@liceovalentina.cl": {
    id: "u5",
    tenantId: "t1",
    nombre: "Roberto Fuentes",
    email: "director@liceovalentina.cl",
    rol: "director",
    colegio: "Liceo Valentina Tereshkova",
  },
  "convivencia@liceovalentina.cl": {
    id: "u11",
    tenantId: "t1",
    nombre: "Carolina Miranda",
    email: "convivencia@liceovalentina.cl",
    rol: "convivencia",
    colegio: "Liceo Valentina Tereshkova",
  },
  "orientador@liceovalentina.cl": {
    id: "u4",
    tenantId: "t1",
    nombre: "Valentina Soto",
    email: "orientador@liceovalentina.cl",
    rol: "orientador",
    colegio: "Liceo Valentina Tereshkova",
  },
  "psicologo@liceovalentina.cl": {
    id: "u10",
    tenantId: "t1",
    nombre: "Daniela Paredes",
    email: "psicologo@liceovalentina.cl",
    rol: "psicologo",
    colegio: "Liceo Valentina Tereshkova",
  },
  "inspector@liceovalentina.cl": {
    id: "u2",
    tenantId: "t1",
    nombre: "Marcela Rivas",
    email: "inspector@liceovalentina.cl",
    rol: "inspector",
    colegio: "Liceo Valentina Tereshkova",
  },
  "profesor@liceovalentina.cl": {
    id: "u3",
    tenantId: "t1",
    nombre: "Carlos Herrera",
    email: "profesor@liceovalentina.cl",
    rol: "profesor_jefe",
    colegio: "Liceo Valentina Tereshkova",
  },
  "docente@liceovalentina.cl": {
    id: "u12",
    tenantId: "t1",
    nombre: "Andrea Vásquez",
    email: "docente@liceovalentina.cl",
    rol: "docente",
    colegio: "Liceo Valentina Tereshkova",
  },
  "admin@liceovalentina.cl": {
    id: "u1",
    tenantId: "t1",
    nombre: "Patricio Muñoz",
    email: "admin@liceovalentina.cl",
    rol: "admin",
    colegio: "Liceo Valentina Tereshkova",
  },
  "sostenedor@liceovalentina.cl": {
    id: "u13",
    tenantId: "t1",
    nombre: "María Elena Correa",
    email: "sostenedor@liceovalentina.cl",
    rol: "sostenedor",
    colegio: "Liceo Valentina Tereshkova",
  },
  // Legacy users for backward compat
  "directivo@liceovalentina.cl": {
    id: "u5",
    tenantId: "t1",
    nombre: "Roberto Fuentes",
    email: "directivo@liceovalentina.cl",
    rol: "director",
    colegio: "Liceo Valentina Tereshkova",
  },
  "saas@convivencia.app": {
    id: "u6",
    tenantId: "saas",
    nombre: "Super Administrador",
    email: "saas@convivencia.app",
    rol: "superadmin",
    colegio: "Plataforma SaaS Ezer",
  },
};

export const mockTenants = [
  { id: "t1", nombre: "Liceo Valentina Tereshkova", slug: "liceo-valentina", plan: "pro", activo: true, usuarios: 34, consultas: 187, documentos: 5, ultimaActualizacion: "2026-05-28" },
  { id: "t2", nombre: "Colegio San Ignacio", slug: "san-ignacio", plan: "starter", activo: true, usuarios: 18, consultas: 52, documentos: 2, ultimaActualizacion: "2026-06-02" },
  { id: "t3", nombre: "Instituto Nacional", slug: "instituto-nacional", plan: "institucion", activo: true, usuarios: 87, consultas: 423, documentos: 8, ultimaActualizacion: "2026-06-08" },
  { id: "t4", nombre: "Escuela República de Francia", slug: "republica-francia", plan: "starter", activo: false, usuarios: 12, consultas: 0, documentos: 0, ultimaActualizacion: "-" },
];

export const mockDocuments = [
  { id: "d1", nombre: "Reglamento Interno de Convivencia Escolar 2025-2026", tipo: "reglamento", ambito: "colegio", estado: "activo", version: 3, fecha: "2026-03-15", tamanho: "2.4 MB", paginas: 48 },
  { id: "d2", nombre: "Protocolo de Actuación frente a Violencia Escolar", tipo: "protocolo", ambito: "colegio", estado: "activo", version: 2, fecha: "2026-01-20", tamanho: "890 KB", paginas: 15 },
  { id: "d3", nombre: "Protocolo de Actuación frente a Acoso Escolar", tipo: "protocolo", ambito: "colegio", estado: "activo", version: 2, fecha: "2026-01-20", tamanho: "760 KB", paginas: 12 },
  { id: "d4", nombre: "Protocolo de Abordaje de Desregulación Emocional", tipo: "protocolo", ambito: "colegio", estado: "procesando", version: 1, fecha: "2026-06-05", tamanho: "620 KB", paginas: 10 },
  { id: "d5", nombre: "PEI - Proyecto Educativo Institucional", tipo: "otro", ambito: "colegio", estado: "activo", version: 1, fecha: "2025-12-01", tamanho: "3.1 MB", paginas: 62 },
];

export const mockQueryLogs = [
  { id: "q1", user: "Marcela Rivas", rol: "inspector", pregunta: "Un estudiante insultó gravemente a un profesor durante la clase", modulo: "consulta_rapida", fecha: "2026-06-10 09:23", util: true, requiereRevision: false },
  { id: "q2", user: "Carlos Herrera", rol: "profesor", pregunta: "Dos estudiantes se agredieron físicamente en el patio durante el recreo", modulo: "consulta_rapida", fecha: "2026-06-10 10:45", util: true, requiereRevision: false },
  { id: "q3", user: "Valentina Soto", rol: "orientador", pregunta: "Un apoderado ingresó sin autorización a la sala de clases a increpar a un profesor", modulo: "consulta_rapida", fecha: "2026-06-09 14:30", util: false, requiereRevision: true },
  { id: "q4", user: "Marcela Rivas", rol: "inspector", pregunta: "Estudiante fue sorprendido con un vaporizador en el baño del colegio", modulo: "consulta_rapida", fecha: "2026-06-09 11:15", util: true, requiereRevision: false },
  { id: "q5", user: "Roberto Fuentes", rol: "directivo", pregunta: "¿Cuál es el procedimiento de expulsión según la normativa vigente?", modulo: "normativa", fecha: "2026-06-08 16:00", util: true, requiereRevision: false },
  { id: "q6", user: "Carlos Herrera", rol: "profesor", pregunta: "Un estudiante ha faltado más de 10 días consecutivos sin justificación", modulo: "consulta_rapida", fecha: "2026-06-08 08:50", util: null, requiereRevision: false },
  { id: "q7", user: "Valentina Soto", rol: "orientador", pregunta: "Protocolo para casos de sospecha de vulneración de derechos", modulo: "consulta_rapida", fecha: "2026-06-07 13:20", util: true, requiereRevision: false },
];

export const dashboardStats = {
  totalConsultas: 187,
  consultasHoy: 23,
  consultasSemana: 67,
  consultasPorModulo: [
    { name: "Consulta Rápida", value: 142 },
    { name: "Normativa", value: 28 },
    { name: "Lectura Guiada", value: 17 },
  ],
  consultasPorRol: [
    { role: "Inspectores", count: 78 },
    { role: "Profesores", count: 54 },
    { role: "Orientadores", count: 32 },
    { role: "Directivos", count: 23 },
  ],
  protocolosMasConsultados: [
    { name: "Violencia Escolar", count: 52 },
    { name: "Acoso Escolar", count: 38 },
    { name: "Faltas Graves", count: 31 },
    { name: "Desregulación Emocional", count: 24 },
    { name: "Mediación Escolar", count: 18 },
  ],
  sinRespuesta: 12,
  pendientesRevision: 5,
  usuariosActivos: 28,
  documentosVigentes: 4,
};